import React from 'react'
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion'; // Added motion
import GetStarted from '../components/GetStarted';
import CardBlogs from '../components/CardBlogs';
import TestimonialCarousel from '../components/TestimonialCarousel';
import testimonialList from '../components/TestimonialsData';
import BestSolutions from '../components/BestSolutions';
// import Solutions from '../components/Solutions';

export default function Home() {

  const homeimg = '/images/home/home.jpg';
  const server_url = process.env.REACT_APP_SERVER;

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Lurantech",
    "url": `${server_url}`,
    "logo": `${server_url}/images/logo.png`,
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-7226-999-101",
      "contactType": "Customer Service",
      "areaServed": "IN",
      "availableLanguage": "English"
    },
    "sameAs": [
      "https://www.facebook.com/Lurantech-107968334690860",
      "https://www.linkedin.com/company/lurantech",
      "https://x.com/lurantech"
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "FF-401, 4th Floor, 7 Sky Complex, Laxmipura, Near VUDA Cross Road",
      "addressLocality": "Vadodara",
      "addressRegion": "Gujarat",
      "postalCode": "390021",
      "addressCountry": "IN"
    },
    "description": "Lurantech provides Liferay development, cloud computing, and digital transformation services to help businesses improve their IT infrastructure and accelerate growth.",
  }

  // Animation Variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.8, ease: "easeOut" } 
    }
  };

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta property="og:title" content="Lurantech | Turning Ideas into Digital Reality" />
          <meta property="og:description" content="Lurantech specializes in cutting-edge tech solutions, including Liferay development, software engineering, cloud computing, and digital transformation." />
          <meta property="og:url" content={`${server_url}/home`} />
          <meta property="og:image" content={`${server_url}${homeimg}`} />
          <meta property="og:type" content="website" />
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="675" />
          
          <meta name="twitter:title" content="Lurantech | Turning Ideas into Digital Reality" />
          <meta name="twitter:description" content="Lurantech offers Liferay development, cloud solutions, and digital transformation to modernize your business with the latest technologies." />
          <meta name="twitter:image" content={`${server_url}${homeimg}`}  />
          <meta name="twitter:card" content="summary_large_image" />
          <meta property="twitter:image:type" content="image/jpeg" />
          <meta property="twitter:image:width" content="1200" />
          <meta property="twitter:image:height" content="675" />
          <meta name="geo.position" content="22.3026;73.1812" />
          <meta name="geo.placename" content="4th Floor - Office 1, 7, Sky Complex, Laxmipura, Vadodara, Gujarat 390021" />
          <meta name="geo.region" content="IN-GJ" />
          <meta property="og:latitude" content="22.3026" />
          <meta property="og:longitude" content="73.1812" />
          <meta property="og:location" content="4th Floor - Office 1, 7, Sky Complex, Laxmipura, Vadodara, Gujarat 390021" />


          <meta name="geo.position" content="22.3072;73.1812" />
          <meta name="geo.placename" content="Vadodara, Gujarat, India" />
          <meta name="geo.region" content="IN-GJ" />

          <meta name="robots" content="index, follow" />
          <meta name="description" content="Lurantech is a leader in Liferay development, offering advanced software solutions, cloud services, and digital transformation to businesses worldwide." />
          <meta name="keywords" content="liferay dxp, dxp cloud, liferay PasS and SasS development, liferay gujarat, liferay india, liferay, liferay development services, liferay consulting, cms solutions, software development, Liferay development, cloud managment, digital transformation, e-commorce solutions, enterprise solutions" />
          <meta name="author" content="Lurantech" />

          <link rel="canonical" href={`${server_url}/home`} />
          <link rel="preload" href={`${server_url}${homeimg}`} as="image" />
          <title>Lurantech | Turning Ideas into Digital Reality</title>
        </Helmet>


        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schemaData),
          }}
        />

        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <GetStarted text1="Agile" text2="Innovation" text3="Quality" button="Let's talk" buttonLink="/contact-us" imagePath="/images/home/getstarted.jpg" />
        </motion.div>

        <h1 className='hide-title'>Lurantech | Turning Ideas into Digital Reality</h1>

        {/* Services Header */}
        <motion.div 
          className="row g-0 py-2 py-md-4 autoshow"
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <div className='text-center head-service-text'>OUR SERVICES</div>
          <div className='text-center head-service-sub-text'>Best solutions for you</div>
        </motion.div>

        {/* Best Solutions Section */}
        <motion.div
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          <BestSolutions />
        </motion.div>

        {/* Testimonials Section */}
        <motion.div
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <TestimonialCarousel testimonials={testimonialList} />
        </motion.div>

        {/* Blogs Section */}
        <motion.div
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <CardBlogs noofblogs='3' />
        </motion.div>

      </HelmetProvider>
    </>
  )
};